import React from 'react';
import './whitepaper.css';

const Whitepaper = () => {
  return (
    <div className="gpt3__cta" id='whitepaper'>
    <div className="gpt3__cta-content">
      {/* <p>Request Early Access to Get Started</p> */}
      <h3>Official Documentation</h3>
    </div>
    <div className="gpt3__cta-btn">
      <button type="button">Whitepaper</button>
    </div>
  </div>
  )
}

export default Whitepaper